export const removeFieldFromObject = <T extends object, K extends keyof T>(obj: T, field: K): Omit<T, K> => Object
  .keys(obj)
  .reduce((acc, key) => {
    if (key !== field) {
      // @ts-ignore TS5: index expression on typed object
      return { ...acc, [key]: obj[key] }
    }
    return acc
  }, {} as Omit<T, K>)
